
export function OpportunitySlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row gap-12">
        <div className="flex-1 flex flex-col justify-start">
          <h2 className="text-[32px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
            AI capability is exploding.<br />Adoption is not.
          </h2>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-8">
            AI agents can automate entire workflows — but law firms, education providers, and financial advisors operate under strict compliance rules. Off-the-shelf AI tools don&apos;t meet their audit, safety, or governance requirements.
          </p>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
            The result: massive potential, near-zero adoption.
          </p>
        </div>

        <div className="w-[35%] shrink-0 flex items-start relative pt-0">
          <div className="flex flex-col justify-start w-full pl-10 -my-4 py-4 gap-6 border-l border-[var(--color-border)]">
            {[
              { value: "45%", label: "CAGR AI agents market to 2030" },
              { value: "$50B", label: "Projected market size by 2030" },
              { value: "< 5%", label: "Professionals using AI agents today" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-[36px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
                  {stat.value}
                </div>
                <div className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Companies used to buy software to help people work better. Soon they&apos;ll buy it to help AI agents work better.
        </p>
        <p className="text-[12px] font-medium text-[var(--color-fg)] mt-0.5">
          COSX is the operating system for that shift.
        </p>
      </div>
    </div>
  );
}
